import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrJobcardPage } from './klmr-jobcard';

@NgModule({
  declarations: [
    KlmrJobcardPage,
  ],
  imports: [
    IonicPageModule.forChild(KlmrJobcardPage),
  ],
})
export class KlmrJobcardPageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-jobcard/klmr-jobcard.module.ts